define('collection/ProviderTimeCollection',['require','lib/collection/BaseCollection','model/ProviderTimelineModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ProviderTimelineModel = require('model/ProviderTimelineModel');

    /**
     * Flexible timeline collection
     *
     * @class TimeFlexibleCollection
     */
    return BaseCollection.extend({

        model: ProviderTimelineModel,
        url: '/booking/time-flexible-multi/',

        getCombinedTimeline: function() {
            var timeline = [];

            this.each(function(model) {
                var groupedCollection = model.collection.getCollectionGroupedByHour();
                groupedCollection.each(function(hourModel) {
                    var dateStr = hourModel.get('date') + ' ' + hourModel.get('time');

                    if (!_.contains(timeline, dateStr)) {
                        timeline.push(dateStr);
                    }
                });
            });


            timeline = timeline.map(function(dateStr) {
                return Date.parseMysqlDate(dateStr);
            });

            timeline.sort();

            return timeline;
        },

        /**
         * Hours of the combined timeline with the per-date client offset of the slots in that hour
         * (server 'time_diff'), for the hour column labels of the view.
         *
         * @return {Array} [{datetime: Date, time_diff: Number|undefined}] sorted by datetime
         */
        getCombinedTimelineHours: function () {
            var hours = {};

            this.each(function (model) {
                model.collection.getCollectionGroupedByHour().each(function (hourModel) {
                    var key = hourModel.get('date') + ' ' + hourModel.get('time');
                    var hour = hourModel.toJSON();

                    if (!hours[key] || (hours[key].time_diff === undefined && hour.time_diff !== undefined)) {
                        hours[key] = {datetime: hour.datetime, time_diff: hour.time_diff};
                    }
                });
            });

            return _.sortBy(_.values(hours), function (hour) { return hour.datetime.getTime(); });
        }

    });

});

